import React from 'react';
import RatingStar from './ratingstar';
import ReviewComment from './reviewcomment'

const Review = () => {
    return (
        <div className='container'>
            <RatingStar />
            <ReviewComment />
        </div>
    );
};

export default Review;